export class SelectableItem<T> {
  public Data: T;
  public Selected: boolean;
  public DisplayText: string;
  public Value: any;

  public constructor(data: T = null, displayText: string = null, selected: boolean = false) {
    this.DisplayText = '';
    if (arguments.length) this.Data = data;
    else this.Data = null;
    if (arguments.length > 1) this.DisplayText = displayText;
    this.Selected = selected;
    this.Value = null;
  }
}
